<template>
  <b-container fluid class='no-paddings'>
    <b-row>
      <b-col sm="3"></b-col>
      <b-col sm="6">
        <date-range-picker ref="picker" :startDate="start_date" :endDate="end_date" @update='updateDateRange'/>
      </b-col>
      <b-col sm="3"></b-col>
    </b-row>
    <br>
    <b-row>
      <b-col sm="3"></b-col>
      <b-col sm="6">
        <v-select :clearable="false" label='name' value='id' placeholder='Select client' class='select-no-caret' v-model='client' :options="clientsWithGroups" />
      </b-col>
      <b-col sm="3"></b-col>
    </b-row>
    <br>
    <b-row>
      <b-col sm="3"></b-col>
      <b-col sm="6">
        <b-form-checkbox v-model="all_clients" value="true" unchecked-value="false">All clients</b-form-checkbox>
      </b-col>
      <b-col sm="3"></b-col>
    </b-row>
    <br>
    <b-row>
      <b-col sm="3"></b-col>
      <b-col sm="6">
        <b-form-checkbox v-model="import_ga" value="true" unchecked-value="false">Google Analytics</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_adwords_adgroups" value="true" unchecked-value="false">Adwords Adgroups</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_adwords_ad" value="true" unchecked-value="false">Adwords Ads</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_adwords_campaigns" value="true" unchecked-value="false">Adwords Campaigns</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_adwords_campaign_conversions" value="true" unchecked-value="false">Adwords Campaign Conversions</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_adwords_keywords" value="true" unchecked-value="false">Adwords Keywords</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_adwords_geo_data" value="true" unchecked-value="false">Adwords Geo Data</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_callrail" value="true" unchecked-value="false">Callrail data</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_bing" value="true" unchecked-value="false">Bing data</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_tradedesk" value="true" unchecked-value="false">Tradedesk data</b-form-checkbox>
        <br>
        <b-form-checkbox v-model="import_geo_tradedesk" value="true" unchecked-value="false">Tradedesk Geo data</b-form-checkbox>
      </b-col>
      <b-col sm="3"></b-col>
    </b-row>
    <br>
    <b-row class='text-center'>
      <b-col sm="12">
        <b-button variant="primary" @click="submit"> {{buttonText}} </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import axios from '../../backend'
import Moment from 'moment'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'

export default {
  name: 'ImportData',
  components: {
    DateRangePicker,
    axios,
    Moment,
    vSelect
  },

  created () {
    this.loadClients()
  },

  computed: {
    startDate: {
      get () {
        return this.$store.getters.startDate
      }
    },
    endDate: {
      get () {
        return this.$store.getters.endDate
      }
    },
    ...mapGetters({
      clientGroups: 'clientGroups'
    })
  },

  mounted () {
    this.start_date = this.startDate
    this.end_date = this.endDate
  },

  data () {
    return {
      client: null,
      all_clients: false,
      clients: [],
      clientsWithGroups: [],
      buttonText: 'Submit',
      start_date: this.startDate,
      end_date: this.endDate,
      import_ga: null,
      import_adwords_ad: null,
      import_adwords_adgroups: null,
      import_adwords_campaigns: null,
      import_adwords_campaign_conversions: null,
      import_adwords_keywords: null,
      import_adwords_geo_data: null,
      import_callrail: null,
      import_bing: null,
      import_tradedesk: null,
      import_geo_tradedesk: null
    }
  },

  methods: {

    loadClients () {
      this.$http.get('/clients')
        .then(function(response) {
          this.clients = response.data
          this.clientsWithGroups = this.clients.concat(this.clientGroups)
        }.bind(this))
        .catch((e) => console.log(e))
    },

    updateDateRange (dateRange) {
      this.start_date = Moment(dateRange.startDate).format('ll')
      this.end_date = Moment(dateRange.endDate).format('ll')
    },

    submit () {
      var data = {
        start_date: this.start_date,
        end_date: this.end_date,
        client: this.client,
        all_clients: this.all_clients
      }
      if (this.import_ga){
        data.import_ga = this.import_ga
      }
      if (this.import_adwords_adgroups){
        data.import_adwords_adgroups = this.import_adwords_adgroups
      }
      if (this.import_adwords_ad){
        data.import_adwords_ad = this.import_adwords_ad
      }
      if (this.import_adwords_campaigns){
        data.import_adwords_campaigns = this.import_adwords_campaigns
      }
      if (this.import_adwords_campaign_conversions) {
        data.import_adwords_campaign_conversions = this.import_adwords_campaign_conversions
      }
      if (this.import_adwords_keywords){
        data.import_adwords_keywords = this.import_adwords_keywords
      }
      if (this.import_adwords_geo_data){
        data.import_adwords_geo_data = this.import_adwords_geo_data
      }
      if (this.import_callrail){
        data.import_callrail = this.import_callrail
      }
      if (this.import_bing){
        data.import_bing = this.import_bing
      }
      if (this.import_tradedesk){
        data.import_tradedesk = this.import_tradedesk
      }
      if (this.import_geo_tradedesk){
        data.import_geo_tradedesk = this.import_geo_tradedesk
      }
      if (this.client === null && this.all_clients === false){
        return false;
      }
      this.buttonText = 'Sending request...'
      this.$http.post('/import_data', data)
        .then(function(){
          this.buttonText = 'Import in progress!'
          setTimeout(()=> this.buttonText = 'Submit', 2000)
       }.bind(this))
    }
  },

}
</script>
<style scoped>
.dropdown {
  background-color: #fff;
}
</style>
